import { background } from 'assets/backgrounds'
import { useArticleTemplate } from 'common/hooks/useArticleTemplate'
import { useInterviewTemplate } from 'common/hooks/useInterviewTemplate'
import { usePodcastsTemplate } from 'common/hooks/usePodcastTemplate'
import PodcastsCard from 'cwp-components/cards/PodcastCard'
import { PostCard } from 'cwp-components/cards/PostCard'
import { useVideoPlayer } from 'hooks/useVideoPlayer'
import { useEffect, useState } from 'react'
import SeeMore from '../../../cwp-components/SeeMore'

interface LatestMediaProps {
  area: string
}

const LatestMedia = ({ area }: LatestMediaProps) => {
  const {
    areaArticles: articles,
    loadArticlesByArea,
    hasMoreAreaArticles,
    loadMoreArticlesByArea,
  } = useArticleTemplate()
  const { featuredHome: interviews, loadFeaturedHomeInterviews } =
    useInterviewTemplate()
  const { featuredHome: podcasts, loadFeaturedHomePodcasts } =
    usePodcastsTemplate()
  const { videoRef } = useVideoPlayer()
  useEffect(() => {
    loadArticlesByArea('area', area)
  }, [area])
  useEffect(loadFeaturedHomeInterviews, [loadFeaturedHomeInterviews])
  useEffect(loadFeaturedHomePodcasts, [loadFeaturedHomePodcasts])
  const [selectedInterview, setSelectedInterview] = useState<any>()

  useEffect(() => {
    if (!selectedInterview && interviews.length)
      setSelectedInterview(interviews[0])
  }, [interviews])

  return (
    <div className='w-full h-auto'>
      <div
        className='relative w-full md:bg-cover md:bg-top md:bg-no-repeat md:min-h-[2355px] h-auto'
        style={{
          backgroundImage: `url(${background.discoverLawTemplate._03})`,
        }}
      >
        <div className='px-2.5 sm:px-4 md:px-6 lg:px-10 xl:px-16 2xl:px-20 box-border'>
          <h3 className='text-lg sm:text-xl md:text-2xl  lg:text-3xl xl:text-4xl 2xl:text-5xl font-bold text-[#101828] leading-none tracking-wide my-2 '>
            Latest Media
          </h3>
          <div className='md:pl-17 md:pr-17 w-full max-w-[1618px] mx-auto h-auto pb-10 flex flex-column gap-12 md:gap-y-25 md:bg-white/40 md:backdrop-blur-[100px] md:rounded-2xl'>
            <div className='rounded-2xl bg-white/40 backdrop-blur-[100px] md:rounded-none md:bg-inherit md:backdrop-blur-0 px-3'>
              <h6 className='text-base font-medium lg:text-lg tracking-wide md:font-bold my-1'>
                Articles and blogs
              </h6>
              <div className='mx-auto w-full max-w-[1498px]'>
                <div className='flex md:flex-row flex-wrap gap-[15px] lg:gap-[24px]'>
                  {articles?.map((blog, idx) => (
                    <PostCard
                      className='min-h-[371px] h-full w-[330px] mx-auto'
                      data={blog}
                      count={idx}
                      key={`${blog.title}-${blog.id}`}
                    />
                  ))}
                </div>
                {hasMoreAreaArticles && articles.length > 0 && (
                  <SeeMore
                    onClick={() => loadMoreArticlesByArea('area', area)}
                  />
                )}
              </div>
            </div>
            <div className='px-3 rounded-2xl bg-[#EBF3FF] backdrop-blur-[100px] md:rounded-none md:bg-inherit md:backdrop-blur-0'>
              <h3 className='text-[#020251] font-medium text-base md:text-lg md:font-bold leading-6 tracking-wide my-2'>
                Podcasts
              </h3>
              <div className='flex gap-6 overflow-x-auto snap-x snap-mandatory scroll-smooth'>
                {podcasts.length > 0 &&
                  podcasts.slice(0, 4).map((episode) => (
                    <div
                      key={episode.uuid}
                      className='w-4/5 max-w-xs sm:w-[25vw] lg:w-full shrink-0 snap-start lg:snap-auto min-h-[34rem]'
                    >
                      <PodcastsCard
                        episode={episode}
                        className='w-full h-full flex flex-col'
                      />
                    </div>
                  ))}
              </div>
              <SeeMore onClick={() => { }} />
            </div>
          </div>
          <p className='text-xs sm:text-sm md:text-base font-medium text-[#001A3D]  leading-6 tracking-wide cursor-pointer my-1'>
            <span className='border-b-[1.5px] border-[#001A3D]'>
              Find a lawyer near you
            </span>
          </p>
        </div>
      </div>
    </div>
  )
}
export default LatestMedia
